import React, { useContext, useState } from "react";
import VerifyUser from "../../Auth/ItemModal/VerifyUser";
import { AccountContext } from "../../User/Account";
import "./Modal.css";

type Props = {
	setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
	component: JSX.Element
};

const Modal = ({ setOpenModal, component }: Props) => {
	return (
		<div className="modalBackground">
			<div className="modalContainer">
				<div className="titleCloseBtn">
					<button
						onClick={() => {
							setOpenModal(false);
						}}
					>
						X
					</button>
				</div>
				{component}
			</div>
		</div>
	);
};

export default Modal;
